"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/dropdown/index.ts
var dropdown_exports = {};
__export(dropdown_exports, {
  ActionDropdown: () => ActionDropdown_default,
  CheckboxDropdown: () => CheckboxDropdown_default,
  CustomDropdown: () => CustomDropdown_default,
  IconDropdown: () => IconDropdown_default,
  SimpleDropdown: () => SimpleDropdown_default,
  dropdownColors: () => dropdownColors
});
module.exports = __toCommonJS(dropdown_exports);
var import_index7 = require("./index.css");

// src/dropdown/actionDropdown/ActionDropdown.tsx
var import_classnames4 = __toESM(require("classnames"));
var import_react5 = require("react");

// src/common/contexts/DropdownContext.tsx
var import_react = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var DropdownContext = (0, import_react.createContext)({
  activeDropdownName: "",
  /**
   * This is a dummy function to satisfy the type checker
   * */
  setActiveDropdownName: (name) => {
  }
});
var useDropdownContext = () => (0, import_react.useContext)(DropdownContext);
var DropdownProviderWrapper = ({
  children
}) => {
  const [activeDropdownName, setActiveDropdownName] = (0, import_react.useState)("");
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    DropdownContext.Provider,
    {
      value: { activeDropdownName, setActiveDropdownName },
      children
    }
  );
};

// src/fontAwesomeV6Icon/FontAwesomeV6Icon.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime2 = require("react/jsx-runtime");
var FontAwesomeV6Icon = ({
  iconStyle,
  iconFamily,
  iconName,
  className,
  title,
  animationType,
  ...HTMLAttributes3
}) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
  "i",
  {
    "data-testid": "font-awesome-v6-icon",
    className: (0, import_classnames.default)(
      iconFamily && `fa-${iconFamily}`,
      iconStyle && `fa-${iconStyle}`,
      iconName && `fa-${iconName}`,
      // Default icon style is solid, but only when no iconFamily prop is provided
      !iconFamily && !iconStyle && "fa-solid",
      animationType && `fa-${animationType}`,
      className
    ),
    title,
    ...HTMLAttributes3
  }
);
var FontAwesomeV6Icon_default = FontAwesomeV6Icon;

// src/dropdown/CustomDropdown.tsx
var import_classnames3 = __toESM(require("classnames"));
var import_react4 = require("react");

// src/button/index.ts
var import_index = require("./index.css");

// src/button/Button.tsx
var import_react3 = require("react");

// src/button/_BaseButton.tsx
var import_classnames2 = __toESM(require("classnames"));
var import_react2 = require("react");

// src/button/_baseButton.module.scss
var baseButton_module_default = {
  "heading-xxl": "_baseButton-module__heading-xxl___kwcRh",
  "heading-xl": "_baseButton-module__heading-xl___6zj6T",
  "heading-lg": "_baseButton-module__heading-lg___d7IqT",
  "heading-md": "_baseButton-module__heading-md___SmDLp",
  "heading-sm": "_baseButton-module__heading-sm___RUZyC",
  "heading-xs": "_baseButton-module__heading-xs___V91tJ",
  "body-one": "_baseButton-module__body-one___jiSyp",
  "body-two": "_baseButton-module__body-two___mLyhO",
  "body-three": "_baseButton-module__body-three___d5NIG",
  "body-four": "_baseButton-module__body-four___Kkh5r",
  "overline-one": "_baseButton-module__overline-one___v-7Xu",
  "overline-two": "_baseButton-module__overline-two___KG-wC",
  "overline-three": "_baseButton-module__overline-three___1RIPW",
  "strong": "_baseButton-module__strong___otOkq",
  "extra-strong": "_baseButton-module__extra-strong___dwGgk",
  "em": "_baseButton-module__em___cb8jk",
  "figcaption": "_baseButton-module__figcaption___7n9Wp",
  "button": "_baseButton-module__button___gGYwf",
  "buttonPendingWithHiddenText": "_baseButton-module__buttonPendingWithHiddenText___1W2Ul",
  "button-withForcedHover": "_baseButton-module__button-withForcedHover___tzWjJ",
  "button-primary": "_baseButton-module__button-primary___2ksGH",
  "button-purple": "_baseButton-module__button-purple___31oil",
  "button-black": "_baseButton-module__button-black___rgoFL",
  "button-white": "_baseButton-module__button-white___1kMMR",
  "button-destructive": "_baseButton-module__button-destructive___2OpdN",
  "button-secondary": "_baseButton-module__button-secondary___BpcuR",
  "button-gray": "_baseButton-module__button-gray___JxYvC",
  "button-tertiary": "_baseButton-module__button-tertiary___MMZKG",
  "button-l": "_baseButton-module__button-l___RV0rB",
  "button-iconOnly": "_baseButton-module__button-iconOnly___zWjVA",
  "button-m": "_baseButton-module__button-m___1eKjJ",
  "button-s": "_baseButton-module__button-s___WsV-p",
  "button-xs": "_baseButton-module__button-xs___VnYav"
};

// src/button/_BaseButton.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var checkButtonPropsForErrors = ({
  icon,
  useAsLink,
  onClick,
  href,
  download,
  text,
  isIconOnly,
  color,
  type
}) => {
  if (color === "gray" && type == "primary" || color === "gray" && type === "tertiary" && !isIconOnly) {
    throw new Error(
      "Expect type prop to be secondary or tertiary(with isIconOnly prop set to true) when color is gray"
    );
  }
  if (color === "purple" && type === "secondary") {
    console.warn(
      "Warning: Button - Secondary Purple color is now deprecated. Please use different color or type. Secondary purple combination will be removed very soon."
    );
  }
  if (useAsLink) {
    if (!href) {
      throw new Error("Expect href prop when useAsLink is true");
    }
    if (onClick) {
      throw new Error(
        "Expect onClick prop to be undefined when useAsLink is true"
      );
    }
  }
  if (!useAsLink) {
    if (!onClick) {
      throw new Error("Expect onClick prop when useAsLink is false");
    }
    if (href) {
      throw new Error(
        "Expect href prop to be undefined when useAsLink is false"
      );
    }
    if (download) {
      throw new Error(
        "Expect download prop to be undefined when useAsLink is false"
      );
    }
  }
  if (isIconOnly) {
    if (!icon) {
      throw new Error("Expect icon prop when isIconOnly is true");
    }
    if (text) {
      throw new Error(
        "Expect text prop to be undefined when isIconOnly is true"
      );
    }
  }
  if (!isIconOnly) {
    if (icon) {
      throw new Error(
        "Expect icon prop to be undefined when isIconOnly is false"
      );
    }
    if (!text) {
      throw new Error("Expect text prop when isIconOnly is false");
    }
  }
};
var spinnerIcon = {
  iconName: "spinner",
  iconStyle: "solid",
  animationType: "spin"
};
var BaseButton = ({
  className,
  id,
  disabled = false,
  isPending = false,
  ariaLabel,
  size = "m",
  type = "primary",
  color = "purple",
  buttonTagTypeAttribute = "button",
  /** Text button specific props */
  iconLeft,
  iconRight,
  text,
  /** IconOnly button specific props*/
  isIconOnly = false,
  icon,
  /** <a> specific props */
  useAsLink = false,
  href,
  target,
  download,
  title,
  /** <button> specific props */
  onClick,
  value,
  name,
  forceHover = false,
  ...rest
}) => {
  const ButtonTag = useAsLink ? "a" : "button";
  const tagSpecificProps = ButtonTag === "a" ? {
    href: disabled ? void 0 : href,
    target,
    /** Copied from old button component. Only need it for the older browsers,
     *  since modern browsers (~2020+ release year secures these vulnerabilities by default) */
    // Opening links in new tabs with 'target=_blank' is inherently insecure. Unfortunately, we depend
    // on this functionality in a couple of place. Fortunately, it is possible to partially mitigate some of
    // the insecurity of this functionality by using the `rel` tag to block some of the potential exploits.
    // Therefore, we do so here.
    rel: target === "_blank" ? "noopener noreferrer" : void 0,
    download,
    title
  } : { type: buttonTagTypeAttribute, onClick, value, name };
  (0, import_react2.useMemo)(
    () => checkButtonPropsForErrors({
      type,
      icon,
      useAsLink,
      onClick,
      href,
      download,
      text,
      isIconOnly,
      color
    }),
    [type, icon, useAsLink, onClick, href, download, text, isIconOnly, color]
  );
  const showIcon = icon && !isPending;
  const showIconLeft = iconLeft && !isPending;
  const showIconRight = iconRight && !isPending || isPending && iconRight && iconLeft;
  const addPendingButtonWithHiddenTextClass = isPending && !icon && !iconLeft && !iconRight;
  const spinnerPosition = iconRight && !iconLeft ? "right" : "left";
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
    ButtonTag,
    {
      className: (0, import_classnames2.default)(
        baseButton_module_default.button,
        baseButton_module_default[`button-${type}`],
        baseButton_module_default[`button-${color}`],
        baseButton_module_default[`button-${size}`],
        forceHover && baseButton_module_default["button-withForcedHover"],
        isIconOnly && baseButton_module_default["button-iconOnly"],
        addPendingButtonWithHiddenTextClass && baseButton_module_default.buttonPendingWithHiddenText,
        className
      ),
      id,
      disabled,
      ...rest,
      "aria-disabled": disabled || rest["aria-disabled"],
      "aria-label": ariaLabel || rest["aria-label"],
      ...tagSpecificProps,
      children: [
        isPending && spinnerPosition === "left" && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...spinnerIcon }),
        showIconLeft && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...iconLeft }),
        showIcon && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...icon }),
        text && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("span", { children: text }),
        showIconRight && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...iconRight }),
        isPending && spinnerPosition === "right" && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...spinnerIcon })
      ]
    }
  );
};
var BaseButton_default = (0, import_react2.memo)(BaseButton);

// src/button/Button.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var buttonColors = {
  purple: "purple",
  black: "black",
  gray: "gray",
  white: "white",
  destructive: "destructive"
};
var Button = (props) => /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(BaseButton_default, { ...props });
var Button_default = (0, import_react3.memo)(Button);

// src/common/constants/index.ts
var componentSizeToBodyTextSizeMap = {
  l: "body-one",
  m: "body-two",
  s: "body-three",
  xs: "body-four"
};
var dropdownColors = {
  white: "white",
  black: "black",
  gray: "gray"
};

// src/common/helpers/index.ts
var getAriaPropsFromProps = (props) => {
  const ariaProps = {};
  Object.keys(props).forEach((key) => {
    if (key.startsWith("aria-")) {
      ariaProps[key] = props[key];
    }
  });
  return ariaProps;
};

// src/dropdown/customDropdown.module.scss
var customDropdown_module_default = {
  "heading-xxl": "customDropdown-module__heading-xxl___BfDpQ",
  "heading-xl": "customDropdown-module__heading-xl___hBTTG",
  "heading-lg": "customDropdown-module__heading-lg___7BsKx",
  "heading-md": "customDropdown-module__heading-md___xxLoj",
  "heading-sm": "customDropdown-module__heading-sm___9iG3J",
  "heading-xs": "customDropdown-module__heading-xs___lrvOk",
  "body-one": "customDropdown-module__body-one___X7Z9b",
  "body-two": "customDropdown-module__body-two___yBWgp",
  "body-three": "customDropdown-module__body-three___wsuRX",
  "body-four": "customDropdown-module__body-four___HuISj",
  "overline-one": "customDropdown-module__overline-one___RpfOR",
  "overline-two": "customDropdown-module__overline-two___vpAsZ",
  "overline-three": "customDropdown-module__overline-three___mVI8k",
  "strong": "customDropdown-module__strong___e5JvH",
  "extra-strong": "customDropdown-module__extra-strong___UAzFh",
  "em": "customDropdown-module__em___-ermV",
  "figcaption": "customDropdown-module__figcaption___GzPqv",
  "dropdownContainer": "customDropdown-module__dropdownContainer___3BIP8",
  "styleAsFormField": "customDropdown-module__styleAsFormField___xI7en",
  "dropdownLabel": "customDropdown-module__dropdownLabel___v0iA-",
  "dropdownButton": "customDropdown-module__dropdownButton___smtEn",
  "readOnly": "customDropdown-module__readOnly___QcxON",
  "helperSection": "customDropdown-module__helperSection___MS5Cc",
  "dropdownMenuContainer": "customDropdown-module__dropdownMenuContainer___MddCb",
  "dropdownMenuItem": "customDropdown-module__dropdownMenuItem___k0-V-",
  "destructiveDropdownMenuItem": "customDropdown-module__destructiveDropdownMenuItem___EN9g6",
  "selectedDropdownMenuItem": "customDropdown-module__selectedDropdownMenuItem___9szis",
  "disabledDropdownMenuItem": "customDropdown-module__disabledDropdownMenuItem___JXRFz",
  "bottomButtonsContainer": "customDropdown-module__bottomButtonsContainer___t9sSU",
  "open": "customDropdown-module__open___vYM0Z",
  "dropdownContainer-left-menuPlacement": "customDropdown-module__dropdownContainer-left-menuPlacement___qGtiT",
  "dropdownContainer-right-menuPlacement": "customDropdown-module__dropdownContainer-right-menuPlacement___a6Zft",
  "dropdownContainer-black": "customDropdown-module__dropdownContainer-black___Vur3p",
  "hasError": "customDropdown-module__hasError___CxxfS",
  "errorSection": "customDropdown-module__errorSection___8w-fJ",
  "activeDropdownButton": "customDropdown-module__activeDropdownButton___I5VEU",
  "dropdownContainer-gray": "customDropdown-module__dropdownContainer-gray___CsmLB",
  "dropdownContainer-white": "customDropdown-module__dropdownContainer-white___p--cG",
  "dropdownContainer-l": "customDropdown-module__dropdownContainer-l___EJinx",
  "dropdownFieldLabel": "customDropdown-module__dropdownFieldLabel___x61Ds",
  "dropdownLabel-thick": "customDropdown-module__dropdownLabel-thick___t8f6S",
  "dropdownLabel-thin": "customDropdown-module__dropdownLabel-thin___PRIj4",
  "dropdownContainer-m": "customDropdown-module__dropdownContainer-m___jkvgP",
  "dropdownContainer-s": "customDropdown-module__dropdownContainer-s___L81BM",
  "dropdownContainer-xs": "customDropdown-module__dropdownContainer-xs___BPccp"
};

// src/dropdown/CustomDropdown.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var CustomDropdown = ({
  name,
  className,
  labelText,
  labelType = "thick",
  children,
  isSomeValueSelected = false,
  icon,
  disabled = false,
  readOnly = false,
  color = dropdownColors.black,
  size = "m",
  menuPlacement = "left",
  useDSCOButtonAsTrigger = false,
  triggerButtonProps = {},
  helperMessage,
  helperIcon,
  errorMessage,
  styleAsFormField = false,
  selectedValueText,
  ...rest
}) => {
  const { activeDropdownName, setActiveDropdownName } = useDropdownContext();
  const dropdownRef = (0, import_react4.useRef)(null);
  const handleClickOutside = (0, import_react4.useCallback)(
    (event) => {
      if (activeDropdownName && dropdownRef.current && event.target instanceof Node && !dropdownRef.current.contains(event.target)) {
        setActiveDropdownName("");
      }
    },
    [dropdownRef, setActiveDropdownName, activeDropdownName]
  );
  const ariaProps = getAriaPropsFromProps(rest);
  (0, import_react4.useEffect)(() => {
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleClickOutside);
    };
  }, [handleClickOutside]);
  (0, import_react4.useEffect)(() => {
    if (useDSCOButtonAsTrigger && !triggerButtonProps) {
      console.warn(
        "Warning: `triggerButtonProps` must be defined when `useDSCOButtonAsTrigger` is true."
      );
    }
  }, [useDSCOButtonAsTrigger, triggerButtonProps]);
  const toggleDropdown = (0, import_react4.useCallback)(() => {
    if (activeDropdownName !== name) {
      setActiveDropdownName(name);
    } else {
      setActiveDropdownName("");
    }
  }, [name, activeDropdownName, setActiveDropdownName]);
  const isOpen = (0, import_react4.useMemo)(
    () => activeDropdownName === name,
    [activeDropdownName, name]
  );
  const onKeyDown = (e) => {
    if (e.key === "Escape") {
      e.currentTarget.classList.remove(customDropdown_module_default.open);
    }
  };
  const triggerComponentProps = {
    id: `${name}-dropdown-button`,
    "data-toggle": "dropdown",
    onClick: toggleDropdown,
    disabled: disabled || readOnly,
    ...ariaProps,
    "aria-haspopup": true,
    "aria-label": ariaProps["aria-label"] || `${name} filter dropdown`
  };
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
      "div",
      {
        id: `${name}-dropdown`,
        className: (0, import_classnames3.default)(
          {
            [customDropdown_module_default.open]: isOpen,
            [customDropdown_module_default.hasError]: errorMessage,
            [customDropdown_module_default.readOnly]: readOnly,
            [customDropdown_module_default.styleAsFormField]: styleAsFormField
          },
          customDropdown_module_default.dropdownContainer,
          customDropdown_module_default[`dropdownContainer-${menuPlacement}-menuPlacement`],
          customDropdown_module_default[`dropdownContainer-${color}`],
          customDropdown_module_default[`dropdownContainer-${size}`],
          className
        ),
        onKeyDown,
        ref: dropdownRef,
        "aria-describedby": ariaProps["aria-describedby"],
        children: [
          styleAsFormField && labelText && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { className: customDropdown_module_default.dropdownFieldLabel, children: labelText }) }),
          useDSCOButtonAsTrigger ? /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
            Button_default,
            {
              ...triggerComponentProps,
              ...triggerButtonProps,
              size,
              forceHover: isOpen,
              "aria-label": (triggerButtonProps == null ? void 0 : triggerButtonProps.isIconOnly) ? labelText : triggerButtonProps["aria-label"] || triggerComponentProps["aria-label"]
            }
          ) : /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
            "button",
            {
              ...triggerComponentProps,
              type: "button",
              className: (0, import_classnames3.default)(
                customDropdown_module_default.dropdownButton,
                isOpen && customDropdown_module_default.activeDropdownButton
              ),
              children: [
                isSomeValueSelected && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { iconName: "check-circle", iconStyle: "solid" }),
                icon && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
                  FontAwesomeV6Icon_default,
                  {
                    iconName: icon.iconName,
                    iconStyle: icon.iconStyle,
                    title: icon.title,
                    className: icon.className
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
                  "span",
                  {
                    className: (0, import_classnames3.default)(
                      customDropdown_module_default.dropdownLabel,
                      customDropdown_module_default[`dropdownLabel-${styleAsFormField ? "thin" : labelType}`]
                    ),
                    children: styleAsFormField ? selectedValueText : labelText
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { iconStyle: "solid", iconName: "chevron-down" })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: customDropdown_module_default.dropdownMenuContainer, children }),
          !errorMessage && (helperMessage || helperIcon) && /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: customDropdown_module_default.helperSection, children: [
            helperIcon && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { ...helperIcon }),
            helperMessage && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { children: helperMessage })
          ] }),
          errorMessage && /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
            "div",
            {
              className: (0, import_classnames3.default)(
                customDropdown_module_default.errorSection,
                customDropdown_module_default.helperSection
              ),
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { iconName: "circle-exclamation" }),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { children: errorMessage })
              ]
            }
          )
        ]
      }
    )
  );
};
var WrappedCustomDropdown = (props) => /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(DropdownProviderWrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(CustomDropdown, { ...props }) });
var CustomDropdown_default = (0, import_react4.memo)(WrappedCustomDropdown);

// src/dropdown/actionDropdown/ActionDropdown.tsx
var import_jsx_runtime6 = require("react/jsx-runtime");
var ActionDropdown = ({
  name,
  className,
  labelText,
  options,
  disabled = false,
  menuPlacement = "left",
  size = "m",
  triggerButtonProps,
  ...rest
}) => {
  const { setActiveDropdownName } = useDropdownContext();
  const onOptionClick = (0, import_react5.useCallback)(
    (optionOnClick) => {
      if (!disabled) {
        optionOnClick();
        setActiveDropdownName("");
      }
    },
    [disabled, setActiveDropdownName]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
    CustomDropdown_default,
    {
      name,
      className,
      labelText,
      disabled,
      menuPlacement,
      size,
      ...rest,
      useDSCOButtonAsTrigger: true,
      triggerButtonProps,
      children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("ul", { children: options.map((option) => {
        const {
          value,
          label,
          onClick,
          isOptionDisabled,
          isOptionDestructive,
          icon: {
            iconName,
            iconStyle,
            title: iconTitle,
            className: iconClassName
          }
        } = option;
        return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("li", { children: /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(
          "button",
          {
            className: (0, import_classnames4.default)(
              customDropdown_module_default.dropdownMenuItem,
              isOptionDisabled && customDropdown_module_default.disabledDropdownMenuItem,
              isOptionDestructive && customDropdown_module_default.destructiveDropdownMenuItem
            ),
            disabled: isOptionDisabled || disabled,
            type: "button",
            onClick: () => onOptionClick(onClick),
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
                FontAwesomeV6Icon_default,
                {
                  iconName,
                  iconStyle,
                  title: iconTitle,
                  className: iconClassName
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("span", { children: label })
            ]
          }
        ) }, value);
      }) })
    }
  );
};
var ActionDropdown_default = ActionDropdown;

// src/dropdown/checkboxDropdown/index.ts
var import_index4 = require("./index.css");

// src/checkbox/index.ts
var import_index3 = require("./index.css");

// src/checkbox/Checkbox.tsx
var import_classnames6 = __toESM(require("classnames"));
var import_react7 = require("react");

// src/typography/index.ts
var import_index2 = require("./index.css");

// src/typography/Typography.tsx
var import_classnames5 = __toESM(require("classnames"));
var import_react6 = require("react");

// ../component-library-styles/typography.module.scss
var typography_module_default = {
  "heading-xxl": "typography-module__heading-xxl___t4Iml",
  "heading-xl": "typography-module__heading-xl___wbMqr",
  "heading-lg": "typography-module__heading-lg___GUMI7",
  "heading-md": "typography-module__heading-md___I661h",
  "heading-sm": "typography-module__heading-sm___2Jm-k",
  "heading-xs": "typography-module__heading-xs___FJljd",
  "body-one": "typography-module__body-one___hKZXX",
  "body-two": "typography-module__body-two___Sa-Eb",
  "body-three": "typography-module__body-three___FIk3k",
  "body-four": "typography-module__body-four___vI1SQ",
  "overline-one": "typography-module__overline-one___rXzIm",
  "overline-two": "typography-module__overline-two___WG6bF",
  "overline-three": "typography-module__overline-three___UK5T-",
  "strong": "typography-module__strong___jtYq4",
  "extra-strong": "typography-module__extra-strong___9SBuV",
  "em": "typography-module__em___2kNMg",
  "figcaption": "typography-module__figcaption___cHscw"
};

// src/typography/Typography.tsx
var import_jsx_runtime7 = require("react/jsx-runtime");
var Typography = ({
  semanticTag,
  visualAppearance,
  children,
  className,
  style,
  id,
  ...props
}) => {
  const Tag = semanticTag;
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
    Tag,
    {
      id,
      className: (0, import_classnames5.default)(typography_module_default[visualAppearance], className),
      style,
      ...props,
      children
    }
  );
};
var Typography_default = (0, import_react6.memo)(Typography);

// src/checkbox/checkbox.module.scss
var checkbox_module_default = {
  "label": "checkbox-module__label___ooRXo",
  "label-xs": "checkbox-module__label-xs___e32xy",
  "label-s": "checkbox-module__label-s___hafkQ",
  "label-m": "checkbox-module__label-m___CBOxg",
  "label-l": "checkbox-module__label-l___7U6JB"
};

// src/checkbox/Checkbox.tsx
var import_jsx_runtime8 = require("react/jsx-runtime");
var Checkbox = ({
  label,
  checked,
  onChange,
  name,
  value,
  disabled = false,
  indeterminate = false,
  size = "m",
  ...HTMLAttributes3
}) => {
  const checkboxRef = (0, import_react7.useRef)(null);
  const bodyTextSize = componentSizeToBodyTextSizeMap[size];
  (0, import_react7.useEffect)(() => {
    if (checkboxRef == null ? void 0 : checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [checkboxRef, indeterminate]);
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
    "label",
    {
      className: (0, import_classnames6.default)(checkbox_module_default.label, checkbox_module_default[`label-${size}`]),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
          "input",
          {
            type: "checkbox",
            ref: checkboxRef,
            name,
            value,
            checked,
            disabled,
            onChange,
            ...HTMLAttributes3
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("i", { className: "fa-solid" }),
        label && /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Typography_default, { semanticTag: "span", visualAppearance: bodyTextSize, children: label })
      ]
    }
  );
};
var Checkbox_default = Checkbox;

// src/dropdown/checkboxDropdown/CheckboxDropdown.tsx
var import_jsx_runtime9 = require("react/jsx-runtime");
var CheckboxDropdown = ({
  name,
  className,
  labelText,
  labelType = "thick",
  allOptions,
  checkedOptions = [],
  onChange,
  disabled = false,
  readOnly = false,
  color = dropdownColors.black,
  size = "m",
  helperMessage,
  helperIcon,
  errorMessage,
  styleAsFormField = false,
  ...rest
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(
    CustomDropdown_default,
    {
      name,
      className,
      labelText,
      labelType,
      color,
      disabled,
      readOnly,
      size,
      isSomeValueSelected: checkedOptions.length > 0,
      helperMessage,
      helperIcon,
      errorMessage,
      styleAsFormField,
      selectedValueText: checkedOptions == null ? void 0 : checkedOptions.map((str) => {
        var _a;
        return (_a = allOptions.find((opt) => opt.value === str)) == null ? void 0 : _a.label;
      }).join(", "),
      ...rest,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("ul", { children: allOptions.map(({ value, label, isOptionDisabled }) => /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("li", { children: /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
          Checkbox_default,
          {
            checked: checkedOptions.includes(value),
            disabled: disabled || isOptionDisabled,
            onChange,
            size,
            name: value,
            value,
            label
          }
        ) }, value)) }),
        !rest.hideControls && /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: customDropdown_module_default.bottomButtonsContainer, children: [
          /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
            Button_default,
            {
              type: "tertiary",
              color: buttonColors.purple,
              text: rest.selectAllText,
              onClick: rest.onSelectAll,
              size
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
            Button_default,
            {
              type: "tertiary",
              color: buttonColors.purple,
              text: rest.clearAllText,
              onClick: rest.onClearAll,
              size
            }
          )
        ] })
      ]
    }
  );
};
var CheckboxDropdown_default = CheckboxDropdown;

// src/dropdown/iconDropdown/index.ts
var import_index5 = require("./index.css");

// src/dropdown/iconDropdown/IconDropdown.tsx
var import_classnames7 = __toESM(require("classnames"));
var import_react8 = require("react");
var import_jsx_runtime10 = require("react/jsx-runtime");
var IconDropdown = ({
  name,
  className,
  labelText,
  labelType = "thick",
  options,
  selectedOption = {},
  onChange,
  disabled = false,
  readOnly = false,
  color = dropdownColors.black,
  size = "m",
  helperMessage,
  helperIcon,
  errorMessage,
  styleAsFormField = false,
  ...rest
}) => {
  const { setActiveDropdownName } = useDropdownContext();
  const onOptionClick = (0, import_react8.useCallback)(
    (option) => {
      if (!disabled && !option.isOptionDisabled) {
        onChange(option);
        setActiveDropdownName("");
      }
    },
    [disabled, onChange, setActiveDropdownName]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
    CustomDropdown_default,
    {
      name,
      className,
      labelText,
      labelType,
      disabled,
      readOnly,
      color,
      icon: selectedOption == null ? void 0 : selectedOption.icon,
      size,
      helperMessage,
      helperIcon,
      errorMessage,
      styleAsFormField,
      selectedValueText: selectedOption == null ? void 0 : selectedOption.label,
      ...rest,
      children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("ul", { children: options.map((option) => {
        const {
          value,
          label,
          isOptionDisabled,
          icon: {
            iconName,
            iconStyle,
            title: iconTitle,
            className: iconClassName
          }
        } = option;
        return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("li", { children: /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)(
          "button",
          {
            className: (0, import_classnames7.default)(
              customDropdown_module_default.dropdownMenuItem,
              isOptionDisabled && customDropdown_module_default.disabledDropdownMenuItem,
              selectedOption.value === value && customDropdown_module_default.selectedDropdownMenuItem
            ),
            disabled: isOptionDisabled || disabled,
            type: "button",
            onClick: () => onOptionClick(option),
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
                FontAwesomeV6Icon_default,
                {
                  iconName,
                  iconStyle,
                  title: iconTitle,
                  className: iconClassName
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("span", { children: label })
            ]
          }
        ) }, value);
      }) })
    }
  );
};
var IconDropdown_default = IconDropdown;

// src/dropdown/simpleDropdown/index.ts
var import_index6 = require("./index.css");

// src/dropdown/simpleDropdown/SimpleDropdown.tsx
var import_classnames8 = __toESM(require("classnames"));

// src/dropdown/simpleDropdown/simpleDropdown.module.scss
var simpleDropdown_module_default = {
  "heading-xxl": "simpleDropdown-module__heading-xxl___9Bn9p",
  "heading-xl": "simpleDropdown-module__heading-xl___Bs827",
  "heading-lg": "simpleDropdown-module__heading-lg___QaJ50",
  "heading-md": "simpleDropdown-module__heading-md___YiLUI",
  "heading-sm": "simpleDropdown-module__heading-sm___1n7ps",
  "heading-xs": "simpleDropdown-module__heading-xs___xW-Fr",
  "body-one": "simpleDropdown-module__body-one___7rX-Y",
  "body-two": "simpleDropdown-module__body-two___gILBB",
  "body-three": "simpleDropdown-module__body-three___GOcL8",
  "body-four": "simpleDropdown-module__body-four___xRcct",
  "overline-one": "simpleDropdown-module__overline-one___-wIiz",
  "overline-two": "simpleDropdown-module__overline-two___k-quH",
  "overline-three": "simpleDropdown-module__overline-three___GCsDi",
  "strong": "simpleDropdown-module__strong___yTyKW",
  "extra-strong": "simpleDropdown-module__extra-strong___5SWar",
  "em": "simpleDropdown-module__em___WbRQ1",
  "figcaption": "simpleDropdown-module__figcaption___9LXRt",
  "dropdownContainer": "simpleDropdown-module__dropdownContainer___Cofpg",
  "styleAsFormField": "simpleDropdown-module__styleAsFormField___Q-XA0",
  "dropdownArrowDiv": "simpleDropdown-module__dropdownArrowDiv___sw7I5",
  "dropdownLabel": "simpleDropdown-module__dropdownLabel___6guyx",
  "iconLeft": "simpleDropdown-module__iconLeft___J-jKr",
  "readOnly": "simpleDropdown-module__readOnly___X-D0o",
  "helperSection": "simpleDropdown-module__helperSection___F4FfB",
  "dropdownContainer-black": "simpleDropdown-module__dropdownContainer-black___IQkAD",
  "hasError": "simpleDropdown-module__hasError___xXvFC",
  "errorSection": "simpleDropdown-module__errorSection___NXOJi",
  "dropdownContainer-gray": "simpleDropdown-module__dropdownContainer-gray___8GY8V",
  "dropdownContainer-white": "simpleDropdown-module__dropdownContainer-white___DjkQ9",
  "dropdownContainer-thin": "simpleDropdown-module__dropdownContainer-thin___F0Lr7",
  "dropdownContainer-l": "simpleDropdown-module__dropdownContainer-l___jHZyS",
  "dropdownContainer-thick": "simpleDropdown-module__dropdownContainer-thick___ZiURJ",
  "dropdownContainer-m": "simpleDropdown-module__dropdownContainer-m___49v5k",
  "dropdownContainer-s": "simpleDropdown-module__dropdownContainer-s___fYXZQ",
  "dropdownContainer-xs": "simpleDropdown-module__dropdownContainer-xs___CaYRZ"
};

// src/dropdown/simpleDropdown/SimpleDropdown.tsx
var import_jsx_runtime11 = require("react/jsx-runtime");
var SimpleDropdown = ({
  items = [],
  itemGroups = [],
  selectedValue,
  onChange,
  name,
  id,
  className,
  labelText,
  iconLeft,
  helperMessage,
  helperIcon,
  errorMessage,
  dropdownTextThickness = "thick",
  isLabelVisible = true,
  disabled = false,
  readOnly = false,
  color = "black",
  size = "m",
  styleAsFormField = false,
  ...rest
}) => /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(
  "label",
  {
    className: (0, import_classnames8.default)(
      simpleDropdown_module_default.dropdownContainer,
      simpleDropdown_module_default[`dropdownContainer-${size}`],
      simpleDropdown_module_default[`dropdownContainer-${color}`],
      simpleDropdown_module_default[`dropdownContainer-${dropdownTextThickness}`],
      styleAsFormField && simpleDropdown_module_default.styleAsFormField,
      className
    ),
    "aria-describedby": rest["aria-describedby"],
    children: [
      isLabelVisible && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("span", { className: simpleDropdown_module_default.dropdownLabel, children: labelText }),
      /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { className: simpleDropdown_module_default.dropdownArrowDiv, children: [
        iconLeft && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
          FontAwesomeV6Icon_default,
          {
            ...iconLeft,
            className: (0, import_classnames8.default)(simpleDropdown_module_default.iconLeft, iconLeft.className)
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
          "select",
          {
            name,
            "aria-label": isLabelVisible ? void 0 : labelText,
            onChange,
            value: selectedValue,
            id,
            disabled: disabled || readOnly,
            className: (0, import_classnames8.default)({
              [simpleDropdown_module_default.hasError]: errorMessage,
              [simpleDropdown_module_default.readOnly]: readOnly
            }),
            ...rest,
            children: itemGroups.length > 0 ? itemGroups.map(({ label, groupItems }, index) => /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("optgroup", { label, children: groupItems.map(({ value, text }) => /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("option", { value, children: text }, value)) }, index)) : items.map(({ value, text }) => /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("option", { value, children: text }, value))
          }
        )
      ] }),
      !errorMessage && (helperMessage || helperIcon) && /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { className: simpleDropdown_module_default.helperSection, children: [
        helperIcon && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(FontAwesomeV6Icon_default, { ...helperIcon }),
        helperMessage && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("span", { children: helperMessage })
      ] }),
      errorMessage && /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(
        "div",
        {
          className: (0, import_classnames8.default)(
            simpleDropdown_module_default.errorSection,
            simpleDropdown_module_default.helperSection
          ),
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(FontAwesomeV6Icon_default, { iconName: "circle-exclamation" }),
            /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("span", { children: errorMessage })
          ]
        }
      )
    ]
  }
);
var SimpleDropdown_default = SimpleDropdown;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ActionDropdown,
  CheckboxDropdown,
  CustomDropdown,
  IconDropdown,
  SimpleDropdown,
  dropdownColors
});
//# sourceMappingURL=index.js.map